import { userRouterMap, adminRouterMap, constantRouterMap } from '@/router'

/**
 * meta role
 * @param roles
 * @param route
 */
function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.indexOf(role) >= 0
  } else {
    return true
  }
}

/**
 * filter
 * @param userRouterMap
 * @param adminRouterMap
 * @param roles
 */
function filterAsyncRouter(userRouterMap, role) {
  const accessedRouters = userRouterMap.filter(route => {
    if (hasPermission(role, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, role)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

function filterAdminRouter(adminRouterMap, role) {
  const accessedRouters = adminRouterMap.filter(route => {
    if (hasPermission(role, route)) {
      if (route.children && route.children.length) {
        route.children = filterAdminRouter(route.children, role)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  getters: {
    permission_routers: state => state.routers,
    addRouters: state => state.addRouters
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    RESET_ROUTERS: (state) => {
      state.routers = undefined
      state.addRouters = []
    }
  },
  actions: {
    GenerateRoutes({ commit }, role) {
      return new Promise(resolve => {
        let accessedRouters
        if (role === 'admin') {
          accessedRouters = filterAdminRouter(adminRouterMap, role)
        } else {
          accessedRouters = filterAsyncRouter(userRouterMap, role)
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    ResetRouters({ commit }) {
      commit('RESET_ROUTERS')
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js